import { DsText } from "@mvp/design-system";
import React from "react";
import { PhoneNumber } from "../../PhoneNumber";
import { ContentTitle } from "./ContentTitle";
import { modalText } from "./modalText";

export const EffectiveDateErrorContent: React.FC = () => {
    return (
        <>
            <ContentTitle text={modalText.callToComplete} />
            <DsText variant="body1" >
                {modalText.effectiveDateError.part1}
                <PhoneNumber
                    color="primary"
                    variant="button"
                    phoneNumber={modalText.effectiveDateError.phoneNumber}
                />
                {modalText.effectiveDateError.part2}
            </DsText>
        </>
    );
};
